import { Route } from 'vue-router';
import AgencyCostScenarioContainerB from '@/modules/agencyCost/views/components/AgencyCostScenarioContainer.vue';
import AgencyCostScenarioInfo from '@/modules/agencyCost/views/1 - ScenarioInfo.vue';
import AgencyCostComparison from '@/modules/agencyCost/views/Comparison.vue';
import AgencyCostActivities from '@/modules/agencyCost/views/2 - Activities.vue';
import AgencyCostResults from '@/modules/agencyCost/views/3 - Results.vue';
import AgencyCostDefaultLineItems from '@/modules/agencyCost/views/EditDefaults.vue';


export const agencyCostPages = [
  { link: '1', text: 'Scenario Information' },
  { link: '2', text: 'Activities' },
  { link: '3', text: 'Results' },
];

export const agencyRoutes = [
  {
    path: '/projects/agency/:pxId',
    name: 'agencyCost',
    redirect: '/projects/agency/:pxId/1',
    component: AgencyCostScenarioContainerB,
    props: (route: Route) => ({
      pxModuleId: route.params.pxId,
      pages: agencyCostPages,
    }),
    children: [
      {
        path: '1',
        component: AgencyCostScenarioInfo,
        props: (route: Route) => ({ pxModuleId: route.params.pxId, page: 1 }),
      },
      {
        path: '2',
        component: AgencyCostActivities,
        props: (route: Route) => ({ pxModuleId: route.params.pxId, page: 2 }),
      },
      {
        path: '3',
        component: AgencyCostResults,
        props: (route: Route) => ({ pxModuleId: route.params.pxId, page: 3 }),
      },
    ],
  },
  {
    path: '/agency/compare',
    name: 'agencyCompare',
    component: AgencyCostComparison,
  },
  {
    path: '/agency/defaults',
    name: 'agencyDefaults',
    component: AgencyCostDefaultLineItems,
  },
];
